export const LEGACY_REQUIREMENTS_CATEGORY = "Requirements";
export const QUERIES_CATEGORY = "Queries";

export const normalizeFollowUpCategory = (category) =>
  category === LEGACY_REQUIREMENTS_CATEGORY ? QUERIES_CATEGORY : category;

export const followUpCategories = [
  "Request",
  "Courtesy",
  "Meeting invite",
  "Program invite",
  "Meeting Touch-point",
  "Program Touch-point",
  QUERIES_CATEGORY,
  "Event Touch-point",
  "Tour Touch-point",
];

export const followUpCategoryFilterOptions = ["", ...followUpCategories];
export const followUpCategoryTabOptions = ["All", ...followUpCategories];
